<template>
  <div>
    <div class="container container_fluid content mb-5">
      <h1>Условия использования сервиса</h1>
      <p>
        Настоящая Оферта регулирует отношения между Администрацией Сервиса
        «Финсайт» (далее - Сервис) – ИП Егоров А.А. (ОГРНИП: 319774600117874) и
        Пользователем Сервиса. Администрация Сервиса и Пользователь в дальнейшем
        могут совместно именоваться «Стороны», а по отдельности - «Сторона».
      </p>
      <p>
        Посещая сайт Сервиса, расположенный по адресу https://finsite.me (далее
        – Сайт), посетитель подтверждает, что прочел, понял и согласен в полном
        объеме соблюдать условия настоящей Оферты. С момента подключения Сервиса
        в соответствии с условиями настоящей Оферты посетитель становится
        пользователем Сервиса (далее – Пользователь).
      </p>
      <p>
        Соблюдение Оферты является обязательным для всех Пользователей и
        посетителей Сайта с момента регистрации на сайте в установленном в
        Оферте порядке или с момента фактического начала пользования сайта, в
        том числе посредством просмотра страниц и материалов, добавления
        информации и т.д.
      </p>
      <p>
        В случае несогласия Пользователя с каким-либо из положений Оферты,
        Пользователь обязан прекратить использование Сайта.
      </p>

      <ol>
        <li v-for="(rule, ruleIndex) of rules" :key="ruleIndex">
          <ol>
            <li>
              <h5>{{ ruleIndex + 1 }}. {{ rule[0] }}</h5>
            </li>
            <li v-for="(item, itemIndex) of rules[ruleIndex][1]" :key="itemIndex">
              <ol v-if="typeof item === 'object'">
                <li>
                  <p>
                    <b>{{ ruleIndex + 1 }}.{{ itemIndex + 1 }}</b> {{ item[0] }}
                  </p>
                </li>
                <li v-for="(subItem, subItemIndex) of item[1]" :key="subItemIndex">
                  <p>
                    <b>
                      {{ ruleIndex + 1 }}.{{ itemIndex + 1 }}.{{
                        subItemIndex + 1
                      }}
                    </b>
                    {{ subItem }}
                  </p>
                </li>
              </ol>

              <p v-else>
                <b>{{ ruleIndex + 1 }}.{{ itemIndex + 1 }}</b> {{ item }}
              </p>
            </li>
          </ol>
        </li>
        <li>
          <ol>
            <li>
              <h5>
                9. Условия предоставления Сервиса Пользователю.
              </h5>
            </li>
            <li>
              <p>
                <b>9.1.</b> Для получения доступа к Сервису Пользователь должен
                подключить Сервис одним из описанных в настоящей Оферте
                способов:
              </p>

              <h6>Для абонентов Tele2. Необходимо:</h6>
              <ul class="list">
                <li>Набрать ussd команду *984*4#;</li>
                <li>
                  Получить доступ подключившись на сайте http://finsite.me/promo
                  или в приложении Теле2;
                </li>
                <li>
                  Нажать кнопку "Начать читать" после ввода номера телефона и
                  кода подтверждения из SMS на сайте finsite.me;
                </li>
              </ul>

              <h6>Подключая сервис, вы:</h6>
              <ul class="list">
                <li>Даете Согласие на обработку своих персональных данных,</li>
                <li>
                  Соглашаетесь с условиями Политики конфиденциальности,
                </li>
                <li>
                  Принимаете Условия использования сервиса “Финсайт”, условия
                  Пользовательского соглашения (публичной оферты) Банка. а также
                  условия Пользовательского соглашения (публичной оферты)
                  Оператора.
                </li>
              </ul>

              <p>
                После подключения сервиса, вам будет направлено SMS-сообщение с
                кодом доступа к статьям на сайте finsite.me.
              </p>
            </li>

            <li>
              <p>
                <b>9.2.</b> До подключения Сервиса Пользователь обязуется
                внимательно прочитать настоящую Оферту.
              </p>
            </li>

            <li>
              <p>
                <b>9.3.</b>
                Пользователь, впервые осуществивший подключение Сервиса, имеет
                возможность бесплатного использования Сервиса (далее -
                Промо-период). Промо-период составляет 3 (три) календарных дня с
                момента подключения Сервиса, при этом срок Промо-периода по
                решению Администрации может быть изменен. <br />
                В случае повторного подключения Пользователем Сервиса
                Промо-период не предоставляется.
              </p>
            </li>

            <li>
              <p>
                <b>9.4.</b> После окончания Промо-периода стоимость
                использования Cервиса посредством Сайта составляет 12 рублей в
                сутки.
              </p>
            </li>

            <li>
              <p>
                <b>9.5.</b> Оплата осуществляется Пользователем со счета
                телефона Оператора посредством Сервиса Оператора (<a
                  href="https://f.tele2.ru/offer/">https://f.tele2.ru/offer/</a>) или банковской картой на сайте. При
                оплате картой стоимость
                составляет 269 рублей за календарный месяц. Оплата производится
                единоразовым платежом.
              </p>
            </li>

            <li>
              <p>
                <b>9.6.</b> По окончании оплаченного периода пользования
                Сервисом автоматически происходит тарификация продления услуг
                пользования Сервисом на такой же срок. Отключение тарификации
                осуществляется одним из способов:
              </p>

              <h6>
                Для абонентов Tele2. Необходимо:
              </h6>
              <ul class="list">
                <li>Набрать ussd команду *984*4*0#;</li>
                <li>
                  Отправить слово СТОП на короткий номер 659;
                </li>
              </ul>
              <p>
                При отключении тарификации доступ к Сервису сохраняется на
                протяжении оставшегося оплаченного периода. По его окончании
                Пользователь теряет доступ ко всем функциям Сервиса.
              </p>
            </li>
            <li>
              <p>
                <b>9.7</b> Возврат денежных средств за оплаченный период
                пользования Сервисом не осуществляется. В случае предъявления
                Пользователем обоснованных претензий относительно качества
                Сервиса, они рассматриваются Администрацией Сервиса в
                индивидуальном порядке. Обращение следует направить по адресу
                <a href="mailto:hello@finsite.me">hello@finsite.me</a>
              </p>
            </li>
            <li>
              <p>
                <b>9.8</b> При регистрации в Сервисе и/или в ходе использования
                Сервиса, Пользователь выражает свое согласие на обработку своих
                персональных данных принимая условия Соглашения об обработке
                персональных данных и Политики конфиденциальности, действующей у
                Администрации Сервиса.
              </p>
            </li>
            <li>
              <p>
                <b>9.9</b> Если по тем или иным причинам одна или несколько норм
                настоящей Оферты является недействительной или не имеющей
                юридической силы, это не оказывает влияния на действительность
                или применимость остальных норм.
              </p>
            </li>
            <li>
              <p>
                <b>9.10</b> Настоящая оферта регулируется и толкуется в
                соответствии с законодательством РФ. Вопросы, не урегулированные
                Офертой, подлежат разрешению в соответствии с законодательством
                РФ.
              </p>
            </li>
            <li>
              <p>
                <b>9.11</b> Пользователь и посетитель Сайта соглашается, что в
                случае возникновения споров они подлежат разрешению в судебном
                порядке в соответствии с действующим законодательством РФ в
                уполномоченном органе судебной власти по месту нахождения
                Администрации Сервиса.
              </p>
            </li>
          </ol>
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
import { getRules } from "@/api/rules";

export default {
  name: "Offer",
  data: () => ({
    rules: getRules()
  })
};
</script>

<style scoped>
h1 {
  margin-bottom: 50px !important;
}

@media screen and (max-width: 800px) {
  h1 {
    font-size: 36px !important;
  }
}

h5,
h6 {
  font-weight: bold !important;
  font-size: 18px !important;
}

h5 {
  font-family: Gilroy;
  line-height: 22px !important;
}

h6 {
  font-family: EB Garamond;
  line-height: 160% !important;
  margin-bottom: 16px !important;
}

.content a {
  color: #0500e5 !important;
  text-decoration: underline;
}

p {
  font-family: EB Garamond;
  font-size: 18px;
  line-height: 160%;
  margin: 16px 0 !important;
}

.content {
  margin-top: 73px;
}

ol {
  padding-left: 0;
}

ol ol ol li:not(:first-child) {
  padding-left: 30px;
}

.content ul {
  margin: 16px 0 !important;
  list-style: circle !important;
}

.content ul li {
  font-family: EB Garamond;
  padding-left: 20px;
  font-size: 18px;
  line-height: 160%;
}

ul ul ul li {
  padding-left: 10px;
}

.list li {
  padding-left: 10px;
  position: relative;
}

.list li::before {
  content: "";
  display: block;
  position: absolute;
  top: 12px;
  left: 0;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #000;
}

@media screen and (max-width: 650px) {
  .content {
    margin-top: 73px;
  }

  h1 {
    padding-top: 93px;

  }
}
</style>
